module.exports = __webpack_public_path__ + "static/media/th-parachute-3.5766fb74.svg";